import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import { CircularProgress, MenuItem, TextField } from "@mui/material";
import "./QAForm.css";
import ResultColumnTSS from "./ResultColumnTSS";
import "../Components/Components.css";
import { QAForm, SaveQAForm } from "../Store/Actions/QAAction";

// const dummy = [
//   {
//     sectionName: "Selling Skill",
//     totalWeight: 29,

//     questions: [
//       {
//         question: "Mengikuti Script Pembukaan Secara Lengkap",
//         weight: 2,
//         resultOptions: ["Yes", "No"],
//       },

//       {
//         question: "Menjelaskan Produk (Manfaat) secara akurat",
//         weight: 15,
//         resultOptions: ["Yes", "No"],
//       },

//       {
//         question: "Kemampuan Menghandle keberatan customer",
//         weight: 10,
//         resultOptions: ["Good", "Average", "Poor"],
//       },

//       {
//         question: "Mengikuti script penutup secara lengkap (Wajib dibacakan)",
//         weight: 2,
//         resultOptions: ["Good", "Average", "Poor"],
//       },
//     ],
//   },

//   {
//     sectionName: "Communication And Listening",
//     totalWeight: 35,

//     questions: [
//       {
//         question:
//           "Memastikan nasabah paham, Mengerti dan butuh akan product yang dijual Ex. Manfaat & premi (Cek & Jeda)",

//         weight: 10,
//         resultOptions: ["Good", "Average", "Poor"],
//       },

//       {
//         question:
//           "Memberikan jawaban secara langsung & akurat sesuai dengan pertanyaan nasabah",

//         weight: 15,
//         resultOptions: ["Yes", "No"],
//       },

//       {
//         question:
//           "Menyampaikan service bank dilakukan sebelum menjelaskan manfaat",

//         weight: 10,
//         resultOptions: ["Yes", "No"],
//       },
//     ],
//   },
// ];

const QAFormTSS = ({
  appID,
  appTypeID,
  setIsQAFormDialogShown,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [form, setForm] = useState(null);

  // Sum of all question weights
  const [totalScore, setTotalScore] = useState(0);

  // Max amount of score attainable
  const [maxScore, setMaxScore] = useState(0);

  // List of individual question score
  const [questionScores, setQuestionScores] = useState([]);

  const [formObject, setFormObject] = useState({});
  const [comment, setComment] = useState("");
  const { myInfo } = useSelector((state) => state.auth);

  // Dummy question used to render on first load (fix CSS not loading on first load)
  const dummyQuestion = {
    ScoreQuestionPartID: 1,
    ScoreQuestionID: 1,
    QuestionIndex: 1,
    Question: "Loading...",
    Weight: 2,
    RequiredScore: 0,
    Score: 100,
    Remarks: null,
    Choice: null,
  };

  useEffect(() => {
    QAForm({
      appid: appID,
      apptypeid: appTypeID,
      taskgroupcode: "QA",
    })
      .then((response) => {
        if (response.status) {
          console.log("QA Form", response.data);
          setForm(response.data);

          const sumScore = response.data.FormParts.reduce(
            (accumulator, currentValue) =>
              accumulator + Number(currentValue.totalweight),
            0
          );

          setMaxScore(sumScore);

          setQuestionScores(
            response.data.QuestionList.map((question) => ({
              id: question.scorequestionid,
              score: Number(question.score === "-1.00" ? 0 : question.score),
            }))
          );

          setTotalScore(
            response.data.QuestionList.reduce((accumulator, currentValue) => {
              const score =
                currentValue.score === "-1.00" || currentValue.score === null
                  ? 0
                  : Number(currentValue.score);

              return accumulator + score;
            }, 0)
          );

          let tempFormObject = {
            ApplicationID: response.data.qaform.ApplicationID,
            Comment: comment,
            RequiredQAScore: response.data.qaform.requiredqascore,
            ScoreFormID: response.data.qaform.scoreformid,
            TotalScore: sumScore,
          };

          response.data.FormParts.forEach((formpart) => {
            tempFormObject[`PartScoreVal_${formpart.scorequestionpartid}`] =
              formpart.totalweight;
          });

          response.data.QuestionList.forEach((question) => {
            tempFormObject[`ScoreQuestionID|${question.scorequestionid}`] =
              JSON.stringify({
                score: question.score,
              });
          });

          setFormObject(tempFormObject);
          setComment(response.data.qaform.ApplicationScore[0].comment);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));
  }, []);

  const renderRating = () => {
    let className, icon, rating;

    if (totalScore <= maxScore / 3) {
      className = "bad";
      icon = "bxs:dislike";
      rating = "Bad";
    } else if (totalScore <= maxScore / 2) {
      className = "good";
      icon = "bxs:like";
      rating = "Good";
    } else {
      className = "excellent";
      icon = "bxs:like";
      rating = "Excellent";
    }

    return (
      <div className={`total-score ${className}`}>
        <div className="score">
          <p className="text">TOTAL SCORE</p>
          <p className="value">{totalScore}</p>
        </div>

        <div className="rating">
          <Icon icon={icon} width="40" height="40" />
          <p>{rating}</p>
        </div>
      </div>
    );
  };

  const handleSubmit = () => {
    setIsSubmitting(true);

    let tempFormObject = formObject;
    tempFormObject.TotalScore = totalScore;
    tempFormObject.Comment = comment;

    questionScores.forEach((question) => {
      tempFormObject[`ScoreQuestionID|${question.id}`] = JSON.stringify({
        Score: question.score,
      });
    });

    console.log("tempFormObject", tempFormObject);
    setFormObject(tempFormObject);

    const payload = {
      appid: appID,
      flag: "OK",
      qaformstring: JSON.stringify(tempFormObject),
      scoringby: myInfo.user.AgentID,
    };

    SaveQAForm(payload)
      .then((response) => {
        if (response.status) {
          console.log("Output data", response.data);

          toast.success("QA form saved successfully", {
            autoClose: 3000,
          });

          setIsSubmitting(false);
          setIsQAFormDialogShown(false);
        } else {
          console.log("error", response.error);
          toast.error("Error saving QA form", { autoClose: 3000 });
          setIsSubmitting(false);
          setIsQAFormDialogShown(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Error saving QA form", { autoClose: 3000 });
        setIsSubmitting(false);
        setIsQAFormDialogShown(false);
      });
  };

  return (
    <div className="qa-form">
      <div className="dialog-container">
        <form method="post">
          <div className="dialog-content">
            <h2 className="title">QA Form</h2>

            <table>
              <thead>
                <tr>
                  <th>No</th>
                  <th>Question</th>
                  <th>Weight</th>
                  <th>Result</th>
                </tr>
              </thead>

              <tbody>
                {form ? (
                  form.FormParts
                    // Sorting to make sure parts are in order
                    .sort((a, b) => a.partindex - b.partindex)

                    // Map the sorted formParts
                    .map((formPart) => (
                      <Fragment key={formPart.scorequestionpartid}>
                        <tr>
                          <td className="section-name" colSpan="4">
                            {`${formPart.title} - ${formPart.totalweight}`}
                          </td>
                        </tr>

                        {form.QuestionList
                          // Filter questions according to formPart
                          .filter(
                            (question) =>
                              question.scorequestionpartid ===
                              formPart.scorequestionpartid
                          )

                          // Sorting to make sure questions are in order
                          .sort((a, b) => a.questionindex - b.questionindex)

                          // Map the filtered and sorted questions
                          .map((question) => (
                            <tr key={question.scorequestionid}>
                              <td>{question.questionindex}</td>
                              <td>{question.question}</td>
                              <td>{question.weight}</td>

                              <td>
                                <ResultColumnTSS
                                  question={question}
                                  setTotalScore={setTotalScore}
                                  questionScores={questionScores}
                                  setQuestionScores={setQuestionScores}
                                />
                              </td>
                            </tr>
                          ))}
                      </Fragment>
                    ))
                ) : (
                  // Render dummy question when data is loading
                  <tr key={dummyQuestion.ScoreQuestionID}>
                    <td>{dummyQuestion.QuestionIndex}</td>
                    <td>{dummyQuestion.Question}</td>
                    <td>{dummyQuestion.Weight}</td>

                    <td>
                      <ResultColumnTSS
                        question={dummyQuestion}
                        setTotalScore={setTotalScore}
                        questionScores={questionScores}
                        setQuestionScores={setQuestionScores}
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Hide when data is loading */}
            {form && (
              <div className="footer">
                <div className="info">
                  <TextField label="POE" select value="1">
                    <MenuItem value="1">POE</MenuItem>
                  </TextField>

                  <TextField
                    label="Comments"
                    minRows={2}
                    multiline
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  />
                </div>

                <div className="summary">
                  {renderRating()}

                  <section className="buttons">
                    <button
                      className="cancel"
                      type="button"
                      onClick={() => setIsQAFormDialogShown(false)}
                    >
                      Cancel
                    </button>

                    <button
                      className="confirm"
                      disabled={isSubmitting}
                      type="button"
                      onClick={() => handleSubmit()}
                    >
                      {isSubmitting && (
                        <CircularProgress className="progress" />
                      )}
                      Save
                    </button>
                  </section>
                </div>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default QAFormTSS;
